import { render, staticRenderFns } from "./MessageFunctionalities.vue?vue&type=template&id=5f57a9b1&scoped=true&"
import script from "./MessageFunctionalities.vue?vue&type=script&lang=js&"
export * from "./MessageFunctionalities.vue?vue&type=script&lang=js&"
import style0 from "./MessageFunctionalities.vue?vue&type=style&index=0&id=5f57a9b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57a9b1",
  null
  
)

export default component.exports